import { KeyRound } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const KeyRoundIcon = createLucideIcon(KeyRound);
